(function groupSearchForm($, Adzuki)
{
	"use strict";

	var form = {
		name     : 'GroupSearchForm',
		submitted: false,
    };
    
    // TODO - Don't makea ajax request if the ships are the same
	$(document).ready(function documentReady()
	{
        Adzuki.Form.registerForm(form);
        $('#groupsearch-vendors').on('change', toggleShips);
        toggleShips();
    });

    function toggleShips()
    {
        var cruise_lines = [];
        $('#groupsearch-vendors option:selected').each(function isCruise(index, el) {
            if ($(el).parent('optgroup').attr('label') === 'Cruise') {
                cruise_lines.push(el.value);
            }
        });

        if (cruise_lines.length > 0) {
            setShips(cruise_lines);
            $('#ship-options').removeClass('hidden');
        } else {
            $('#ship-options').addClass('hidden');
            $('#groupsearch-ships').html('');
            $('#groupsearch-ships').selectpicker('refresh');
        }
    }

    function setShips(cruise_lines)
    {
        var key            = null;
        var opt_group      = '';
        var cruise_line_id = null;
        var selected_ships = $('#groupsearch-ships').val();

        Adzuki.Ajax.get('/Groups/shipsByVendor/' + cruise_lines.join(','))
        .then(function setShipOptions(response) {
            $('#groupsearch-ships').html('');
            for (key in response) {
                if (key !== '0') {
                    opt_group = '<optgroup label="' + key + '">';
                    for (cruise_line_id in response[key]) {
                        if (cruise_line_id.match(/\d/)) {
                            opt_group += '<option value="' + cruise_line_id + '">' + response[key][cruise_line_id] + '</option>';
                        }
                    }
                    opt_group += '</optgroup>';
                    $('#groupsearch-ships').append(opt_group);
                }
            }
            $('#groupsearch-ships').val(selected_ships); // we replaced all options - add the selected ships back as values
            $('#groupsearch-ships').selectpicker('refresh');    // make bootstrap-select update it's UI based on new options
        });
    }

}(jQuery, window.Adzuki || {}));